<form nz-form nzLayout="vertical" novalidate [formGroup]="currencyForm">
  <div class="row">
    <div class="col-md-12">
      <nz-form-item>
        <nz-form-label>Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input name" formControlName="name">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Code</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input code" formControlName="code">
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <nz-form-item>
    <nz-form-control>
      <div *nzModalFooter>
        <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
        <button nz-button nzType="primary" (click)="save()" [disabled]="currencyForm.invalid || isSaving">{{btnLabel}}</button>
      </div>
    </nz-form-control>
  </nz-form-item>
</form>
